document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mega-menu').forEach(menu => {
    const details = menu.closest('details') || menu;
    const summary = details.querySelector('summary');
    const isDesktop = window.innerWidth >= 990;

    if (!details) return;

    const open = () => {
      if (isDesktop) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', true);
      }
    }

    const close = () => {
      if (isDesktop) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', false);
      }
    }

    // Desktop hover open
    menu.addEventListener('mouseenter', () => {
      open();
    });

    menu.addEventListener('focusin', () => {
      open();
    });

    menu.addEventListener('mouseleave', () => {
      close();
    });

    // Prevent click toggling on desktop
    if (summary) {
      summary.addEventListener('click', e => {
        if (isDesktop) {
          e.preventDefault();
        }
      });
    }
  });
});
